import React from 'react';
import { Box, Button, Typography, IconButton, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@mui/icons-material/Delete';
import { FileToUpload } from '../types';

interface SelectedFilesListProps {
  filesToUpload: FileToUpload[];
  onRemoveFile: (index: number) => void;
  onUploadFiles: () => void;
}

const SelectedFilesList: React.FC<SelectedFilesListProps> = ({
  filesToUpload,
  onRemoveFile,
  onUploadFiles
}) => {
  const { t } = useTranslation();

  if (filesToUpload.length === 0) return null;

  return (
    <Box mt={2}>
      <Typography variant="subtitle2" gutterBottom>
        {t('screening_profile.selected_files')}
      </Typography>
      {filesToUpload.map((file, index) => (
        <Box key={index} display="flex" alignItems="center" mb={1}>
          <CircularProgress size={16} sx={{ mr: 1 }} />
          <Typography variant="body2" sx={{ flexGrow: 1 }}>
            {file.fileName} - {t('uploading')}...
          </Typography>
          <IconButton
            size="small"
            onClick={() => onRemoveFile(index)}
            color="error"
          >
            <DeleteIcon />
          </IconButton>
        </Box>
      ))}
    </Box>
  );
};

export default SelectedFilesList; 